/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import queryString from 'query-string';
import {REPORT_TAG_REQUEST, REPORT_TAG_SUCCESS, REPORT_TAG_FAILURE} from "../../types";

const ReportTagAction = (params = []) => ({

    [RSAA]: {
        endpoint: () => {
            let queryParam = queryString.stringify(params);

            return `${SERVER_API_FB_BOT}/api/conversation-summary?${queryParam}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            REPORT_TAG_REQUEST,
            {
                type: REPORT_TAG_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": REPORT_TAG_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: REPORT_TAG_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": REPORT_TAG_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {ReportTagAction}